import React from "react";
import { AutocompleteInput, Filter, ReferenceInput } from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	return (
		<Filter {...props} variant="outlined">
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn
				{...bookmakersConfig.reference}
				fullWidth
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</Filter>
	);
};
export default Filters;
